var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1TrafficLights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 18v-3h-5v-4a4 4 0 00-4-4H28a4 4 0 00-4 4v4h-5v3l5 4v7h-5v3l5 4v7h-5v3l5 4v3a4 4 0 004 4h8v12h4V57h8a4 4 0 004-4v-3l5-4v-3h-5v-7l5-4v-3h-5v-7l5-4zm-9 35H28V11h20v42zM33.5 19.25a4.5 4.5 0 114.5 4.5 4.49 4.49 0 01-4.5-4.5zm0 12.75a4.5 4.5 0 114.5 4.5 4.49 4.49 0 01-4.5-4.5zm0 12.75a4.5 4.5 0 114.5 4.5 4.49 4.49 0 01-4.5-4.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Traffic_lights.81c721e3.svg";
export { SvgI1TrafficLights as ReactComponent };